import { Flow_0_0_2 } from '@flexus/core';

export const BET_13: Flow_0_0_2 = {
	id: '13',
	name: 'cancelled_claim',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: 'Placeholder'
		},
		viewRoles: {
			0: 'Placeholder'
		}
	},
	startNode: '',
	nodes: {}
};
